import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LetsGoButton, WelcomeRocket, WelcomeSubtitle, WelcomeTitle } from '../Screen1';

import { CourseOffer } from '../Screen2.5';

import DestinationConnector from '../Screen4';

import { QuickSubscriptionPicker } from '../Screen6';

import ReadyToLaunchAdvanced from '../AdvancedScreen7';

// import { ItemsImportedTitle, ItemsImportedBody } from '../AdvancedScreen8';
// import NonApiSelection from '../Screen3.5/NonApiSelection';

export default {
  steps: [
    // {
    //   // default
    //   target: 'body',
    //   placement: 'center',
    //   // other
    //   title: <FormattedMessage id="onboarding.screen2.title" />,
    //   subtitle: <FormattedMessage id="onboarding.screen2.subtitle" />,
    //   showProgress: true,
    //   showBackground: true,
    //   content: <LevelPicker />,
    //   bigContent: true,
    //   primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
    //   secondaryButtonContent: '',
    //   currentStage: 1,
    //   storeActionBeforeNext: 'updateUserProfile',
    // },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      content: <CourseOffer />,
      showProgress: true,
      showBackground: false,
      title: <FormattedMessage id="onboarding.screen2.5.title" />,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      // secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 0,
      forCourse: true,
      // biggerContent: true,
    },
    {
      // default
      target: 'body',
      placement: 'center',
      // other
      title: <FormattedMessage id="onboarding.screen4.title" />,
      subtitle: <FormattedMessage id="onboarding.screen4.subtitle" />,
      // subtitle: <WelcomeSubtitle />,
      showBackground: true,
      content: <DestinationConnector />,
      showProgress: true,
      bigContent: true,
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 1,
    },
    {
      target: 'body',
      content: <QuickSubscriptionPicker advanced />,
      title: <FormattedMessage id="onboarding.screen6.title" />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="onboarding.buttons.next" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      biggerContent: true,
      currentStage: 6,
      skipHeight: 80,
    },
    {
      target: 'body',
      content: <ReadyToLaunchAdvanced forOnboarding width="300px" />,
      title: <FormattedMessage id="onboarding.advanced.screen7.title" />,
      subtitle: <FormattedMessage id="onboarding.advanced.screen7.subtitle" />,
      showProgress: true,
      showBackground: true,
      placement: 'center',
      primaryButtonContent: <FormattedMessage id="settingsModal.import" />,
      secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
      currentStage: 2,
      showSkip: true,
      bigContent: true,
      skipHeight: 80,
      storeActionBeforeNext: 'importCSV',
    },
    // {
    //   target: 'body',
    //   placement: 'center',
    //   title: <ItemsImportedTitle />,
    //   bigContent: true,
    //   showBackground: true,
    //   showSkip: true,
    //   showProgress: false,
    //   content: <ItemsImportedBody />,
    //   primaryButtonContent: <FormattedMessage id="onboarding.buttons.finish" />,
    //   secondaryButtonContent: <FormattedMessage id="onboarding.buttons.previous" />,
    //   skipHeight: 244,
    // },
    {
        // default
        target: 'body',
        placement: 'center',
        // other
        content: <WelcomeRocket />,
        bigContent: true,
        currentStage: 3,
        showProgress: false,
        title: <WelcomeTitle />,
        subtitle: <WelcomeSubtitle />,
        primaryButtonContent: <LetsGoButton />,
        secondaryButtonContent: '',
        showBackground: false,
      },
  ],
};